export default __webpack_public_path__ + "static/media/eua-flag.0e43949c.svg";